import React from 'react';
import { Button } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import Icon from '../../../Icon/Icon';
import Trigger from '../Trigger/Trigger';
import { DIRECTION_FORWARD } from '../Trigger/Trigger.constants';
import './NextTrigger.less';
var defaultProps = {
  content: /*#__PURE__*/React.createElement(Button, {
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: "arrow-right"
  })),
  onClick: function onClick() {}
};
export default function NextTrigger(_ref) {
  var content = _ref.content,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Trigger, {
    content: content,
    onClick: onClick,
    direction: DIRECTION_FORWARD
  });
}
NextTrigger.defaultProps = defaultProps;